import React, { useContext, useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Avatar,
  LinearProgress,
  Stack,
  Divider,
  IconButton,
} from "@mui/material";
import UIButton from "components/ui/form/UIButton";
import ChatIcon from "@mui/icons-material/Chat";
import ParticularsDialog from "../particularPlan";
import { AVAILABLE_LANGUAGES } from "config/helpers/multilingual_helper";
import { useSelector } from "react-redux";
import UISelect from "components/ui/select/UISelect";
import usa_flag from "../../assets/images/usa_flag.png";
import french_flag from "../../assets/images/french_flag.png";
import polish_flag from "../../assets/images/polish_flag.png";
import spain_flag from "../../assets/images/spain_flag.png";
import { Close, Logout } from "@mui/icons-material";
import WbSunnyIcon from "@mui/icons-material/WbSunny";
import ThemeSwitch from "../ui/ThemeSwitch";
import i18n from "multilingual";
import { useDispatch } from "react-redux";
import {
  change_app_language,
  change_audio_language,
  change_auto_delete_days,
  change_login,
  handle_print_watermark,
  reset_state,
} from "redux/actions/AppActions";
import { SidebarContext } from "mobile/mobileComponents/sidebarContext";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { isEqual } from "lodash";
import { cleanName } from "config/helpers/common_helper";
import specialityOptions from "config/helpers/specialityData.json";
import TextAvatar from "components/avatar/TextAvatar";
import { SAVE_USER_SETTINGS } from "adapters/ehr.service";
import { set_current_user_setting } from "redux/actions/AuthActions";
import CommonProgress from "components/loader/commonProgress";
import { useNavigate } from "react-router-dom";
import SupportCard from "components/wrapper_v2/SupportCard";
import UISwipeableDrawer from "components/drawers/SwipeableDrawer";
import CloseIcon from "@mui/icons-material/Close";
import MobileSelect from "mobile/ui/MobileSelect";
import MenuThemeSwitch from "mobile/ui/switches/MenuThemeSwitch";
import LogoutIcon from "mobile/ui/icons/LogoutIcon";
import Confirmation from "../../components/ui/ConfirmationDialog/ConfirmationDialog";
import { LOGOUT_FROM_SERVER } from "../../adapters/auth.service";
import { constants } from "../../redux/constants/redux-constants";
import { getCurrentPlan } from "../../screens/store/storeHelper";

const MobileSideMenu = () => {
  const getFlag = (code) => {
    switch (code) {
      case "en":
        return usa_flag;
      case "es":
        return spain_flag;
      case "pl-PL":
        return polish_flag;
      case "fr-FR":
        return french_flag;
      default:
        break;
    }
  };

  const app = useSelector((state) => state.app, isEqual);

  const reduxDispatch = useDispatch();
  const [currentFlag, setCurrentFlag] = useState(getFlag(app?.language));
  const { openSidebar, closeSidebar, isSidebarOpen } =
    useContext(SidebarContext);
  const practitionerData = useSelector(
    (state) => state?.auth?.practitionerData
  );
  const personData = useSelector(
    (state) => state?.auth?.personData
  );
  const userFirstname = personData?.name?.[0]?.text
    ?.split(" ")
    ?.slice(0, 2)
    ?.join(" ");
  const theme = useSelector((state) => state?.app?.theme);
  const currentUserPracticeData = useSelector(
    (state) => state?.auth?.currentUserPracticeData
  );
  const currentUserSettingsData = useSelector(
    (state) => state?.auth?.currentUserSettings
  );
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(true);
  const navigate = useNavigate();
  const [isSupportDrawerOpen, setIsSupportDrawerOpen] = useState(false);
  const [openAlert, setOpenAlert] = useState(false);

  const currentPlan = getCurrentPlan();

  function getSpecialtyLabel(code) {
    const specialty = specialityOptions.find((item) => item.value === code);
    return specialty ? specialty.label : null;
  }

  const updateUserSetting = async (updateValue, moduleName) => {
    debugger;
    let setting = {
      ...currentUserSettingsData?.display,
      ...updateValue,
    };
    console.log(
      "setting---",
      setting,
      "-currentUserSettingsData-",
      currentUserSettingsData,
      "-updateValue-",
      updateValue
    );

    let payload = structuredClone(currentUserSettingsData?.resource);
    payload.extension = [
      {
        url: "http://enliv.com/settings/data",
        valueString: JSON.stringify(setting),
      },
    ];
    try {
      if (moduleName === "theme") {
        setLoading(true);
      }
      if (moduleName === "print_watermark") {
        reduxDispatch(handle_print_watermark(updateValue?.print_watermark));
      }
      if (moduleName === "auto_delete_days") {
        reduxDispatch(change_auto_delete_days(updateValue?.auto_delete_days));
      }
      const response = await SAVE_USER_SETTINGS(`PUT`, payload);
      const rawData = { ...response?.data };
      const displaySetting = rawData?.extension?.find(
        (item) => item?.url === "http://enliv.com/settings/data"
      )?.valueString;
      reduxDispatch(
        set_current_user_setting({
          resource: { ...rawData },
          display: JSON?.parse(displaySetting),
        })
      );
    } catch (e) {
      console.error(e);
    } finally {
      console.log("updated user settings");
      if (moduleName === "theme") {
        setLoading(false);
      }
    }
  };

  const handleThemeChange = async (event) => {
    if (app?.theme === "light") {
      updateUserSetting({ theme: "dark" }, "theme");
    } else {
      updateUserSetting({ theme: "light" }, "theme");
    }
    setChecked(event?.target?.checked);
  };

  useEffect(() => {
    setChecked(app?.theme === "light" ? false : true);
  }, [app.theme]);

  const navigateToAllPlans = () => {
    debugger;
    closeSidebar("main");
    navigate("/store/plans");
  };
  const handleLogout = () => {
    const language = app?.language;
    LOGOUT_FROM_SERVER();
    reduxDispatch(change_login(constants?.USER_LOGOUT));
    reduxDispatch(reset_state());
    reduxDispatch(change_app_language(language || "en"));
  };
  const handleLogoutClick = () => {
    setOpenAlert(true);
  };

  const handleSupportClick = () => {
    // closeSidebar("main");
    // setIsSupportDrawerOpen(true);
    navigate("/supportChat");
  };

  return (
    <>
      {openAlert && (
        <Confirmation
          open={openAlert}
          setOpen={setOpenAlert}
          title={i18n.t(`Side_Menu.SIGN_OUT?`)}
          message={i18n.t(`Side_Menu.LOGOUT_ALERT`)}
          callback={handleLogout}
          autoFocus={"cancel"}
          cancelFunction={() => setOpenAlert(false)}
        />
      )}
      <Box
        sx={{
          bgcolor: app?.theme === "light" ? "#f9f9f9" : "#1B1E3D",
          height: "100dvh",
          width: "100%",
          // color: 'white',
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        {/* Top Section */}
        <Box
          className="border"
          sx={{
            display: "flex",
            alignItems: "center",
            p: 4,
            background: app?.theme === "light" ? "#fff" : "#272652",
            borderBottomWidth: 1,
            borderColor: "#9A8F8F66",
            border: "thin",
          }}
        >
          <TextAvatar
            text={userFirstname}
            sx={{
              marginRight: "0px",
              height: "6dvh",
              width: "6dvh",
              borderRadius: "50%",
              fontSize: "12px",
              padding: "1.6vw",
              marginBottom: "1vw",
            }}
          />
          <Box sx={{ ml: 2, flex: 1 }}>
            <div>{cleanName(personData?.name?.[0]?.text)}</div>
            <Typography variant="body2" sx={{ color: "#B8B9C3" }}>
              {currentUserPracticeData?.practiceData?.isFirstVisitSkipped
                ? ""
                : practitionerData?.qualification?.[0]?.code?.coding?.[0]
                    ?.display === "Other"
                ? `${i18n.t(`SPECIALTY.OTHER`)} - ${
                    practitionerData?.qualification?.[0]?.code?.coding?.[0]
                      ?.code
                  }`
                : i18n.t(
                    `SPECIALTY.${getSpecialtyLabel(
                      practitionerData?.qualification?.[0]?.code?.coding?.[0]
                        ?.code
                    )}`
                  ) ||
                  practitionerData?.qualification?.[0]?.code?.coding?.[0]
                    ?.display}
            </Typography>
          </Box>
          {/* Cancel button */}
          <IconButton
            className="border"
            style={{
              borderRadius: "10px",
              borderWidth: "0.5px",
              borderColor: "#FFFFFF29",
              padding: "6px",
            }}
            onClick={() => closeSidebar("main")}
          >
            <CloseIcon size={14} style={{ padding: 0, margin: 0 }} />
          </IconButton>
        </Box>

        {/* Medium Section */}
        <Box sx={{ m: 2, flex: 1, display: "flex", flexDirection: "column" }}>
          <Box
            sx={{ display: "flex", flexDirection: "column", gap: 2, flex: 1 }}
          >
            <UIButton
              variant="outlined"
              color="primary"
              className="rounded-pill p-2 border-secondary p-1 px-2 text-white text-capitalize"
              text={i18n.t("common.Help")}
              fullWidth
              style={{
                background:
                  "linear-gradient(to right, #2B2C7780 50%, #BCB8B880)",
              }}
              // callback={handleSupportClick}
              callback={() => {
                closeSidebar("main");
                navigate("/home/support");
              }}
            />
            <UIButton
              fullWidth
              variant="contained"
              sx={{
                "&:hover": {
                  bgcolor: app?.theme === "light" ? "#f9f9f9" : "#7C4DEF",
                },
                textTransform: "none",
              }}
              // text={{i18n.t(`FEATURES.${currentPlan}`)} ?? "See All Plans"}
              text={i18n.t(`FEATURES.${currentPlan}`)}
              className="rounded-pill p-2 p-1 px-2 text-white"
              style={{
                background:
                  "linear-gradient(to right, #D5B0F3 5%, #8C68C3 , #6754A7)",
              }}
              // callback={navigateToAllPlans}
              callback={() => {
                closeSidebar("main");
                navigate("/home/planparticulars");
              }}
            />
          </Box>
        </Box>

        {/* Bottom Section */}
        <Box
          sx={{ bgcolor: app?.theme === "light" ? "#f9f9f9" : "#1B1E3D" }}
          className="w-100 d-flex flex-column "
        >
          <Box
            sx={{
              height: "44px",
              ml: 2.5,
              mr: 2,
            }}
          >
            <MobileSelect
              menuplacement = "top"
              options={AVAILABLE_LANGUAGES}
              selectedValues={AVAILABLE_LANGUAGES?.find(
                (f) => f?.code === app?.language
              )}
              onChange={(e) => {
                i18n.changeLanguage(e?.code);
                setCurrentFlag(getFlag(e.code));
                updateUserSetting({
                  language: e?.code,
                  // audioLanguage: e?.code,
                });
                reduxDispatch(change_app_language(e?.code));
                // reduxDispatch(change_audio_language(e?.code));
              }}
              startIcon={
                <img
                  src={currentFlag}
                  alt="Language Flag"
                  style={{
                    width: 24,
                    height: 24,
                  }}
                />
              }
            />
          </Box>
          <hr   />
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              px: 1,
              paddingRight: 2,
            }}
          >
            <Box sx={{ display: "flex", alignItems: "center" }}>
              <WbSunnyIcon className="ms-3 me-3" />
              <div style={{ fontSize: "0.9rem", fontFamily: "Poppins" }}>
                {i18n.t("settings2.THEME")}
              </div>
            </Box>
            {loading ? (
              <CommonProgress />
            ) : (
              <>
                <MenuThemeSwitch
                  checked={checked}
                  onChange={handleThemeChange}
                />
              </>
            )}
          </Box>
          <hr />
          <Button
            sx={{
              mx: 2,
              color: "#FDAAA4",
              justifyContent: "flex-start",
              gap: 1,
              marginBottom: 2,
            }}
            onClick={handleLogoutClick}
          >
            <LogoutIcon
              style={{
                color: "#FDAAA4",
              }}
            />
            <div
              style={{
                fontSize: "0.9rem",
                fontWeight: "500",
                fontFamily: "Poppins",
                color: "#FDAAA4",
                textTransform: "none"
              }}
            >
              {i18n.t("Side_Menu.Sign_out")}
            </div>
          </Button>
        </Box>
      </Box>
    </>
  );
};

export default MobileSideMenu;
